import { CHECK_TOKEN_URL, LOGIN_SUCCESS, LOGIN_ERROR } from "./types";
import axios from "axios";
//检测登陆
export const checkAuth = () => {
  return dispatch => {
    axios({
      method: "get",
      url: `${CHECK_TOKEN_URL}`,
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("X-AUTH-TOKEN")
      }
    }).then(function(res) {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: res
      });
    }).catch(err=>{
      dispatch({
        type: LOGIN_ERROR,
        payload: "用户未登录"
      });
    })
  };
};
